export default {"src":"/_next/static/media/vn.141fbfcc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};